import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { PROFILE, TOOLS } from "@/data";
import { Reveal, SectionHeading } from "@/components/Reveal";

export default function Portrait() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);

  return (
    <section id="story" ref={ref} data-testid="portrait-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute top-1/3 right-0 w-[28rem] h-[28rem] rounded-full bg-[#D9A441]/10 blur-[130px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 relative">
          <Reveal>
            <div className="relative" data-testid="portrait-frame">
              <div className="absolute -top-3 -left-3 w-10 h-10 border-t-2 border-l-2 border-[#D9A441] z-10" />
              <div className="absolute -bottom-3 -right-3 w-10 h-10 border-b-2 border-r-2 border-emerald-400 z-10" />
              <div className="overflow-hidden rounded-xl border border-white/10 shadow-xl shadow-black/40">
                <motion.img
                  style={{ y, objectPosition: "center 25%" }}
                  src={PROFILE.portrait}
                  alt={PROFILE.name}
                  data-testid="portrait-image"
                  className="w-full aspect-[4/5] object-cover scale-[1.35]"
                />
              </div>
              <div className="absolute bottom-5 left-5 right-5 flex justify-between gap-3">
                <span className="text-xs font-mono bg-[#0A1730]/85 backdrop-blur border border-white/10 rounded-full px-3 py-1.5 text-emerald-400">5+ Years Active</span>
                <span className="text-xs font-mono bg-[#0A1730]/85 backdrop-blur border border-white/10 rounded-full px-3 py-1.5 text-[#D9A441]">100% On-Time Delivery</span>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <SectionHeading id="story" overline="Story / 02" title="Marketer by strategy. Developer by craft." />
          <Reveal delay={0.1}>
            <p className="text-base sm:text-lg text-[#9DAEC4] leading-relaxed max-w-2xl">
              I'm Sumon — a government-verified freelancer from Bangladesh working at the intersection of growth and code.
              I run performance campaigns across Meta and Google, engineer affiliate funnels that convert cold traffic into
              commissions, and build the fast, search-ready websites that hold it all together.
            </p>
            <p className="mt-5 text-base sm:text-lg text-[#9DAEC4] leading-relaxed max-w-2xl">
              One person, full stack of growth: strategy, traffic, and the technology underneath it.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-wrap gap-3" data-testid="tools-stack">
              {TOOLS.map((t) => (
                <span key={t} className="text-xs font-mono uppercase tracking-widest text-[#C8D3E0] border border-white/15 rounded-full px-4 py-2 bg-white/5 hover:border-[#D9A441]/50 hover:text-[#D9A441] transition-colors duration-300">
                  {t}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
